import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeletedUserIndexComponent } from './deleted-user-index/deleted-user-index.component';
import {DeletedUserRoutesModule} from './deleted-user-routes/deleted-user-routes.module';
import {TableDeletedUserModule} from '../../resources/tables/table-deleted-user/table-deleted-user.module';
import {CardModule} from '../../resources/components/card/card.module';


@NgModule({
  declarations: [DeletedUserIndexComponent],
  imports: [
    CommonModule,
    DeletedUserRoutesModule,
    CardModule,
    TableDeletedUserModule
  ]
})
export class DeletedUserModule { }
